import { Component } from '@angular/core';
import { faBars, faUpload } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'realwear-cloud-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent {
  readonly burgerMenu = faBars;
  readonly faUpload = faUpload;

  navigateTo(url: string) {
    window.open(url, '_blank');
  }
}
